// Juna Theme JS

// Nav scroll shadow
const nav = document.querySelector('.juna-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.style.boxShadow = window.scrollY > 20 ? '0 2px 20px rgba(44,74,53,0.08)' : 'none';
  });
}

// Mobile: auto-hide the nav on scroll-down (swipe up) and reveal it on
// scroll-up (swipe down), so the menu is reachable anywhere on the page —
// not only when scrolled to the very top. Desktop nav stays put.
(function () {
  if (!nav) return;
  var lastY = window.scrollY;
  var ticking = false;
  var THRESHOLD = 6; // ignore tiny scroll jitter
  function update() {
    ticking = false;
    var y = window.scrollY;
    if (window.innerWidth > 900 || y < 80) {
      // On desktop, or near the top of the page, always show the nav
      nav.classList.remove('nav-hidden');
      lastY = y;
      return;
    }
    var dy = y - lastY;
    if (Math.abs(dy) < THRESHOLD) return;
    if (dy > 0) {
      // scrolling down (finger swiping up) → hide, and close the dropdown
      nav.classList.add('nav-hidden');
      var m = document.querySelector('.mobile-menu-combined');
      if (m) m.style.display = 'none';
    } else {
      // scrolling up (finger swiping down) → reveal
      nav.classList.remove('nav-hidden');
    }
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 900) nav.classList.remove('nav-hidden');
  }, { passive: true });
})();

// Mobile nav toggle — combines the nav link lists into one dropdown
function closeMenu() {
  const m = document.querySelector('.mobile-menu-combined');
  if (m) m.style.display = 'none';
}

function toggleMenu() {
  let mobileMenu = document.querySelector('.mobile-menu-combined');
  if (!mobileMenu) {
    mobileMenu = document.createElement('div');
    mobileMenu.className = 'mobile-menu-combined nav-links open';
    mobileMenu.style.display = 'none';

    document.querySelectorAll('.nav-links-left a, .nav-links-right a').forEach(link => {
      const clone = link.cloneNode(true);
      // Close the menu as soon as a link is tapped so it never lingers over the page
      clone.addEventListener('click', closeMenu);
      mobileMenu.appendChild(clone);
    });

    // Anchor inside the nav so the dropdown scrolls away with it
    (nav || document.body).appendChild(mobileMenu);
  }

  mobileMenu.style.display = mobileMenu.style.display === 'none' ? 'flex' : 'none';
}

// Close the dropdown when tapping anywhere outside it (but not the hamburger)
document.addEventListener('click', (e) => {
  const m = document.querySelector('.mobile-menu-combined');
  if (m && m.style.display !== 'none' && !m.contains(e.target) && !e.target.closest('.nav-hamburger')) {
    closeMenu();
  }
});

// Close the dropdown once the user actually scrolls (small threshold so a
// finger resting on the screen doesn't dismiss it)
(function () {
  let menuScrollStart = null;
  window.addEventListener('scroll', () => {
    const m = document.querySelector('.mobile-menu-combined');
    if (!m || m.style.display === 'none') { menuScrollStart = null; return; }
    if (menuScrollStart === null) { menuScrollStart = window.scrollY; return; }
    if (Math.abs(window.scrollY - menuScrollStart) > 30) { closeMenu(); menuScrollStart = null; }
  }, { passive: true });
})();

// Soft scroll-reveal — sections and cards fade up gently as they enter the
// viewport. Class-based (added only when JS runs) so content is never hidden
// without JS, and skipped entirely for reduced-motion users.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll(
    '.product-card, .value-item, .products-header, .section-label, .section-title, .trust-item, .footer-logo-area, .product-trust-list'
  );
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in-view'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) {
    // Stagger siblings inside the same grid/row so groups cascade in
    var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains(el.classList[0]); }) : [];
    var i = sibs.indexOf(el);
    if (i > 0) el.style.transitionDelay = Math.min(i * 70, 350) + 'ms';
    el.classList.add('reveal');
    io.observe(el);
  });
})();

// Quantity stepper (PDP)
window.JunaQty = function (d) {
  var i = document.getElementById('pdpQty');
  if (!i) return;
  i.value = Math.max(1, (parseInt(i.value, 10) || 1) + d);
};

/* ---------- Cart (Shopify AJAX) ---------- */
(function () {
  var FREE_SHIP = window.JUNA_FREE_SHIP_PAISE || 50000; // paise
  function el(id) { return document.getElementById(id); }
  function money(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }

  function open(e) {
    if (e && e.preventDefault) e.preventDefault();
    refresh();
    var d = el('cartDrawer'), o = el('cartOverlay');
    if (d) { d.classList.add('show'); d.setAttribute('aria-hidden', 'false'); }
    if (o) o.classList.add('show');
    document.body.style.overflow = 'hidden';
    return false;
  }
  function close() {
    var d = el('cartDrawer'), o = el('cartOverlay');
    if (d) { d.classList.remove('show'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('show');
    document.body.style.overflow = '';
  }

  function add(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  function render(cart) {
    if (!cart) return;
    var badge = el('navCartBadge');
    if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
    var items = el('cartItems');
    if (items) {
      if (!cart.items || !cart.items.length) {
        items.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      } else {
        items.innerHTML = cart.items.map(function (it) {
          var img = it.image
            ? '<img src="' + it.image.replace(/(\.[^.\/?]+)(\?|$)/, '_120x$1$2') + '" alt="">'
            : '<div class="cart-item-ph"></div>';
          return '<div class="cart-item">' +
            '<div class="cart-item-img">' + img + '</div>' +
            '<div class="cart-item-bd">' +
              '<div class="cart-item-nm">' + it.product_title + '</div>' +
              '<div class="cart-item-qty">' +
                '<button type="button" onclick="JunaCart.changeQty(\'' + it.key + '\',' + (it.quantity - 1) + ')" aria-label="Decrease">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" onclick="JunaCart.changeQty(\'' + it.key + '\',' + (it.quantity + 1) + ')" aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-item-right">' +
              '<div class="cart-item-price">' + money(it.final_line_price) + '</div>' +
              '<button type="button" class="cart-item-rm" onclick="JunaCart.changeQty(\'' + it.key + '\',0)">Remove</button>' +
            '</div>' +
          '</div>';
        }).join('');
      }
    }
    var sub = el('cartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
    var fill = el('cartShipFill'), txt = el('cartShipText');
    if (fill) fill.style.width = Math.min(100, cart.total_price / FREE_SHIP * 100) + '%';
    if (txt) {
      txt.innerHTML = cart.total_price >= FREE_SHIP
        ? 'You’ve unlocked <b>free shipping!</b>'
        : 'Add <b>' + money(FREE_SHIP - cart.total_price) + '</b> more for <b>free shipping</b>';
    }
    var foot = el('cartFoot'); if (foot) foot.style.display = cart.item_count ? 'block' : 'none';
  }

  var tT;
  function toast(m) {
    var t = el('cartToast'); if (!t) return;
    t.textContent = m; t.classList.add('show');
    clearTimeout(tT); tT = setTimeout(function () { t.classList.remove('show'); }, 1900);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var qSel = btn.getAttribute('data-qty-from');
    var qInput = qSel ? document.querySelector(qSel) : null;
    var qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
    var buyNow = btn.hasAttribute('data-buy-now');
    btn.classList.add('is-loading');
    add(vid, qty).then(function () {
      btn.classList.remove('is-loading');
      if (buyNow) { window.location.href = '/checkout'; return; }
      toast('Added to cart');
      open();
    }).catch(function () {
      btn.classList.remove('is-loading');
      toast('Sorry — couldn’t add that. Please try again.');
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('DOMContentLoaded', refresh);

  window.JunaCart = { open: open, close: close, add: add, changeQty: changeQty, refresh: refresh };
})();

/* ---------- Gift note ----------
   Saves the message as a cart attribute so it travels through checkout and
   shows up on the order in admin. Every gift-note block on the page stays in
   sync, so the drawer and the cart page never disagree. */
(function () {
  var SAVE_DELAY = 700;
  var timer;

  function blocks() { return document.querySelectorAll('[data-gift-note]'); }

  function save(value, statusEl) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift note': value } })
    }).then(function (r) {
      if (!r.ok) throw new Error('save failed');
      if (statusEl) {
        statusEl.textContent = value ? 'Saved' : '';
        clearTimeout(statusEl._t);
        statusEl._t = setTimeout(function () { statusEl.textContent = ''; }, 2000);
      }
    }).catch(function () {
      if (statusEl) statusEl.textContent = 'Not saved — try again';
    });
  }

  // Mirror the value into every other gift-note block on the page
  function sync(value, checked, origin) {
    blocks().forEach(function (b) {
      if (b === origin) return;
      var t = b.querySelector('[data-gift-text]');
      var c = b.querySelector('[data-gift-toggle]');
      var body = b.querySelector('.gift-note-body');
      if (t && t.value !== value) t.value = value;
      if (c) c.checked = checked;
      if (body) body.hidden = !checked;
    });
  }

  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-gift-toggle]');
    if (!toggle) return;
    var block = toggle.closest('[data-gift-note]');
    var body = block.querySelector('.gift-note-body');
    var text = block.querySelector('[data-gift-text]');
    body.hidden = !toggle.checked;
    if (toggle.checked) {
      if (text) text.focus();
    } else if (text) {
      // Unticking clears the note so a stale message never ships
      text.value = '';
      save('', block.querySelector('[data-gift-status]'));
    }
    sync(text ? text.value : '', toggle.checked, block);
  });

  document.addEventListener('input', function (e) {
    var text = e.target.closest('[data-gift-text]');
    if (!text) return;
    var block = text.closest('[data-gift-note]');
    sync(text.value, true, block);
    clearTimeout(timer);
    timer = setTimeout(function () {
      save(text.value.trim(), block.querySelector('[data-gift-status]'));
    }, SAVE_DELAY);
  });

  // Flush any pending edit before checkout so nothing is lost
  document.addEventListener('click', function (e) {
    var go = e.target.closest('.btn-cart-checkout, [href="/checkout"]');
    if (!go) return;
    var text = document.querySelector('[data-gift-text]');
    if (!text || !timer) return;
    clearTimeout(timer);
    e.preventDefault();
    save(text.value.trim()).then(function () { window.location.href = '/checkout'; });
  });
})();

// Featured product showcase carousel (homepage)
document.querySelectorAll('.featured-carousel').forEach((car) => {
  const track = car.querySelector('.featured-track');
  const slides = car.querySelectorAll('.featured-slide');
  const dots = car.querySelectorAll('.featured-dot');
  const n = slides.length;
  if (!track || n < 2) return;
  let idx = 0;
  function go(i) {
    idx = (i % n + n) % n;
    track.style.transform = 'translateX(' + (-idx * 100) + '%)';
    dots.forEach((d, j) => d.classList.toggle('is-active', j === idx));
  }
  const next = car.querySelector('.featured-next');
  const prev = car.querySelector('.featured-prev');
  if (next) next.addEventListener('click', () => go(idx + 1));
  if (prev) prev.addEventListener('click', () => go(idx - 1));
  dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.getAttribute('data-index'), 10))));
});
